(function ($) {
  "use strict";

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function replaceGformButtons(root) {
    const $root = root ? $(root) : $(document);

    $root
      .find('input.gform_button[type="submit"]')
      .not("[data-gf-replaced]")
      .each(function () {
        const $input = $(this);

        const buttonText = $input.val() || "";
        const buttonId = $input.attr("id");
        const onClick = $input.attr("onclick");

        const $button = $("<button/>", {
          type: "submit",
          id: buttonId,
          class: "gform_button btn btn-primary",
          "data-gf-replaced": "true",
          text: buttonText,
        });

        if (onClick) $button.attr("onclick", onClick);

        [
          "name",
          "tabindex",
          "title",
          "aria-label",
          "aria-describedby",
          "data-submission-type",
          "disabled",
          "form",
        ].forEach((attr) => {
          const val = $input.attr(attr);
          if (val != null) $button.attr(attr, val);
        });

        $input.replaceWith($button);
      });
  }

  function observeWrapper($wrapper) {
    if (!$wrapper.length || $wrapper.data("gf-observing")) return;

    const debouncedReplace = debounce(() => replaceGformButtons($wrapper), 10);

    const observer = new MutationObserver((mutations) => {
      const needsReplace = mutations.some((m) =>
        Array.from(m.addedNodes || []).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('input.gform_button[type="submit"]') ||
              $(node).find('input.gform_button[type="submit"]').length),
        ),
      );

      if (needsReplace) debouncedReplace();
    });

    observer.observe($wrapper[0], { childList: true, subtree: true });
    $wrapper.data("gf-observing", true);
  }

  function init() {
    replaceGformButtons();
    $(".gform_wrapper").each(function () {
      observeWrapper($(this));
    });
  }

  $(init);

  $(document).on(
    "gform_post_render gform_page_loaded gform_post_conditional_logic",
    init,
  );

  if (window.gform?.addAction) {
    gform.addAction("gform_post_render", init);
    gform.addAction("gform_page_loaded", init);
    gform.addAction("gform_post_conditional_logic", init);
  }

  // Track form submissions via dataLayer
  function trackFormSubmission(formId) {
    // Get page information
    var pageInfo = {
      url: window.location.href,
      title: document.title,
      referrer: document.referrer || "",
    };

    // Build dataLayer object
    var dataLayerEvent = {
      event: "gform_submit_successful",
      form_id: formId,
      page_info: pageInfo,
      timestamp: Date.now(),
      event_category: "form",
      event_action: "submit",
      event_label: "Form " + formId,
      source_url: window.location.href,
    };

    // Push to dataLayer
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(dataLayerEvent);
  }

  // Handle form submission events
  $(document).on("gform_confirmation_loaded", function (event, formId) {
    trackFormSubmission(formId);
  });
})(jQuery);
